import {
    FormControl,
    MenuItem,
    Select,
    InputLabel,
    Box,
    Button,
    TextField,
    Alert,
    CircularProgress,
    Card,
    CardContent,
    Typography,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import { ZIELMUSKEL_OPTIONS, KATEGORIE_OPTIONS } from "./constants";

function UebungForm({ data, fieldErrors, submitError, loading, onChange, onSubmit }) {
    return (
        <Card sx={{ mb: 3 }}>
            <CardContent>
                <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                    Neue Übung anlegen
                </Typography>

                <Box component="form" onSubmit={onSubmit} noValidate>
                    {submitError && (
                        <Alert severity="error" sx={{ mb: 2 }}>
                            {submitError}
                        </Alert>
                    )}

                    <TextField
                        sx={{ mb: 2 }}
                        label="Name"
                        fullWidth
                        required
                        value={data.name}
                        onChange={onChange("name")}
                        error={!!fieldErrors.name}
                        helperText={fieldErrors.name}
                    />

                    <TextField
                        sx={{ mb: 2 }}
                        label="Beschreibung"
                        fullWidth
                        multiline
                        rows={3}
                        value={data.beschreibung}
                        onChange={onChange("beschreibung")}
                    />

                    <FormControl fullWidth sx={{ mb: 2 }}>
                        <InputLabel>Zielmuskel</InputLabel>
                        <Select
                            label="Zielmuskel"
                            value={data.zielmuskel}
                            onChange={onChange("zielmuskel")}
                        >
                            <MenuItem value="">
                                <em>Kein Zielmuskel</em>
                            </MenuItem>
                            {ZIELMUSKEL_OPTIONS.map(({ value, label }) => (
                                <MenuItem key={value} value={value}>
                                    {label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <FormControl
                        fullWidth
                        sx={{ mb: 2 }}
                        required
                        error={!!fieldErrors.kategorie}
                    >
                        <InputLabel>Kategorie</InputLabel>
                        <Select
                            label="Kategorie"
                            value={data.kategorie}
                            onChange={onChange("kategorie")}
                        >
                            <MenuItem value="">
                                <em>Bitte wählen</em>
                            </MenuItem>
                            {KATEGORIE_OPTIONS.map(({ value, label }) => (
                                <MenuItem key={value} value={value}>
                                    {label}
                                </MenuItem>
                            ))}
                        </Select>
                        {fieldErrors.kategorie && (
                            <Typography
                                variant="caption"
                                color="error"
                                sx={{ mt: 0.5, ml: 1.75, display: "block" }}
                            >
                                {fieldErrors.kategorie}
                            </Typography>
                        )}
                    </FormControl>

                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        disabled={loading}
                        startIcon={
                            loading ? (
                                <CircularProgress size={16} color="inherit" />
                            ) : (
                                <SaveIcon />
                            )
                        }
                    >
                        {loading ? "Wird gespeichert…" : "Speichern"}
                    </Button>
                </Box>
            </CardContent>
        </Card>
    );
}

export default UebungForm;
